import { cardFaceFor, useDeck } from '@lunary/ui-web/deck'
import { cardLabel, cardName } from '@lunary/app-core/reading-chat-model'
import styles from './readings.module.css'

const MAJORS = Array.from({ length: 22 }, (_, i) => i)
const MAX = 3

export function CardPicker({ value, onChange }: { value: number[]; onChange: (next: number[]) => void }) {
  const deck = useDeck()
  const toggle = (n: number) =>
    onChange(value.includes(n) ? value.filter((v) => v !== n) : value.length < MAX ? [...value, n] : value)
  return (
    <div className={styles.picker}>
      <div className={styles.pickerHead}>
        <b>Карты (необязательно)</b>
        <span>{value.length > 0 ? `${value.map(cardLabel).join(', ')} · до ${MAX}` : `Можно не выбирать: разбор уйдёт без карт. Или отметьте до ${MAX}`}</span>
        {value.length > 0 && (
          <button type="button" className={styles.linkBtn} onClick={() => onChange([])}>
            Сбросить
          </button>
        )}
      </div>
      <div className={styles.strip}>
        {MAJORS.map((n) => (
          <button key={n} type="button" aria-pressed={value.includes(n)} aria-label={cardLabel(n)} onClick={() => toggle(n)}>
            <img src={cardFaceFor(deck, n) ?? ''} alt="" draggable={false} />
            {cardName(n)}
          </button>
        ))}
      </div>
    </div>
  )
}
